export type SermaoStatus = 'rascunho' | 'publicado' | 'agendado'

export interface Sermao {
  id: string
  titulo: string
  tema: string
  serie?: string
  referencia_principal: string
  descricao: string
  data: string
  status: SermaoStatus
  tags: string[]
  duracao_estimada: number
  created_at: string
  updated_at: string
}

export const mockSermoes: Sermao[] = [
  {
    id: '1',
    titulo: 'Vivendo pela fe',
    tema: 'Fe e perseveranca',
    serie: 'Romanos',
    referencia_principal: 'Romanos 1:16-17',
    descricao:
      'Reflexao sobre a justica de Deus revelada pela fe e como viver de forma pratica esse principio.',
    data: '2024-11-24T09:00:00Z',
    status: 'publicado',
    tags: ['fe', 'justica', 'perseveranca'],
    duracao_estimada: 38,
    created_at: '2024-10-10T07:30:00Z',
    updated_at: '2024-10-18T12:15:00Z',
  },
  {
    id: '2',
    titulo: 'Esperanca em tempos dificeis',
    tema: 'Esperanca',
    serie: 'Cartas de Pedro',
    referencia_principal: '1 Pedro 1:3-9',
    descricao:
      'Mensagem de encorajamento destacando a viva esperanca que temos em Cristo mesmo em meio as provacoes.',
    data: '2024-12-01T09:00:00Z',
    status: 'agendado',
    tags: ['esperanca', 'provas', 'encorajamento'],
    duracao_estimada: 42,
    created_at: '2024-10-14T09:10:00Z',
    updated_at: '2024-10-14T09:10:00Z',
  },
  {
    id: '3',
    titulo: 'O chamado para servir',
    tema: 'Servico',
    serie: 'Vida abundante',
    referencia_principal: 'Marcos 10:42-45',
    descricao:
      'Estudo sobre o exemplo de Cristo como servo e como podemos refletir esse coracao no cotidiano da igreja.',
    data: '2024-10-27T09:00:00Z',
    status: 'publicado',
    tags: ['servico', 'lideranca', 'humildade'],
    duracao_estimada: 35,
    created_at: '2024-09-30T08:00:00Z',
    updated_at: '2024-10-02T11:00:00Z',
  },
  {
    id: '4',
    titulo: 'Restaurando a alegria',
    tema: 'Restauracao',
    referencia_principal: 'Salmos 51:10-12',
    descricao:
      'Meditacao sobre a oracao de Davi e como Deus restaura a alegria do coracao arrependido.',
    data: '2024-11-17T09:00:00Z',
    status: 'rascunho',
    tags: ['arrependimento', 'adoracao', 'renovacao'],
    duracao_estimada: 33,
    created_at: '2024-10-20T10:20:00Z',
    updated_at: '2024-10-21T16:45:00Z',
  },
]
